/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SelectCalendarMutationResponse,
  SelectCalendarPathParams,
  SelectCalendar400,
  SelectCalendar404,
  SelectCalendar500,
} from '../types/SelectCalendar'

function getSelectCalendarUrl({
  id,
  integration_id,
}: {
  id: SelectCalendarPathParams['id']
  integration_id: SelectCalendarPathParams['integration_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/calendar-integration/${integration_id}/calendars/${id}/select/` as const,
  }
  return res
}

/**
 * @description Select a calendar for First Bite to use.
 * @summary Select a calendar for First Bite to use
 * {@link /api/v1/calendar-integration/:integration_id/calendars/:id/select/}
 */
export async function selectCalendar(
  {
    id,
    integration_id,
  }: {
    id: SelectCalendarPathParams['id']
    integration_id: SelectCalendarPathParams['integration_id']
  },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SelectCalendarMutationResponse,
    ResponseErrorConfig<
      SelectCalendar400 | SelectCalendar404 | SelectCalendar500
    >,
    unknown
  >({
    method: 'POST',
    url: getSelectCalendarUrl({ id, integration_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
